import { render, staticRenderFns } from "./ph-add.vue?vue&type=template&id=df7cc314&scoped=true"
import script from "./ph-add.vue?vue&type=script&lang=js"
export * from "./ph-add.vue?vue&type=script&lang=js"
import style0 from "./ph-add.vue?vue&type=style&index=0&id=df7cc314&prod&scoped=true&lang=css"
import style1 from "./ph-add.vue?vue&type=style&index=1&id=df7cc314&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7cc314",
  null
  
)

export default component.exports